import React from "react";
import Slider from "react-slick";
import { Box, Typography, Avatar, Paper } from "@mui/material";
import clientcomment from "../../assets/happycl.jpg";

// Sample testimonials data
// const testimonials = [
// 	{
// 		name: "Ball Emily",
// 		title: "CEO, Acme Corp",
// 		image: "https://randomuser.me/api/portraits/women/44.jpg",
// 		quote:
// 			"Trading with Valorcrypt has been great. It has beautiful low spreads and there are options where you can choose the best or suitable trading account. Also, withdrawals on the same day are fantastic. Globalextrade is the best broker. Please keep it up.",
// 	},
// 	{
// 		name: "Russell Jacob",
// 		title: "Developer, Tech Solutions",
// 		image: "https://randomuser.me/api/portraits/men/32.jpg",
// 		quote:
// 			"Valorcrypt is an easy and smooth trading experience, better than any other platform. Also, the peer-to-peer transaction, I find it revolutionary and the best for us traders world.",
// 	},
// 	{
// 		name: "Elizabeth Kayleigh",
// 		title: "Designer, Creatives Inc.",
// 		image: "https://randomuser.me/api/portraits/women/65.jpg",
// 		quote:
// 			"I'm happy with the service provided. Valorcrypt always updates me on what's happening and gives daily statements of accounts. And the staff is very responsive and always ready to assist.",
// 	},
// 	{
// 		name: "Hailey Rose",
// 		title: "Designer, Creatives Inc.",
// 		image: "https://randomuser.me/api/portraits/women/65.jpg",
// 		quote:
// 			"Valorcrypt is by far the best binary options brokerage. It has over 5 different types of binary options unlike other brokers. The payments are fast and it's really amazing. Thanks Globalextrade.",
// 	},
// 	{
// 		name: "Joseph Jeremy",
// 		title: "Designer, Creatives Inc.",
// 		image: "https://randomuser.me/api/portraits/women/65.jpg",
// 		quote:
// 			"Superb support. No hassle at all with withdrawals. Perfect trading conditions.Everything a trader could look for!",
// 	},
// ];

const testimonials = [
	{
		name: "Alex Morgan",
		title: "Chief Operating Officer, BrightFuture Ltd.",
		image: "https://randomuser.me/api/portraits/women/44.jpg",
		quote:
			"Trading with Velorcrypt has been excellent. It offers competitive spreads and various options to select the most suitable trading account. Withdrawals are processed on the same day, which is impressive. Velorcrypt remains the top broker. Keep up the great work!",
	},
	{
		name: "Michael Carter",
		title: "Software Engineer, Innovatech",
		image: "https://randomuser.me/api/portraits/men/32.jpg",
		quote:
			"Velorcrypt provides a seamless and user-friendly trading experience, surpassing other platforms I've used. The peer-to-peer transactions are revolutionary, making it ideal for traders around the globe.",
	},
	{
		name: "Samantha Lee",
		title: "Creative Director, DesignHub",
		image: "https://randomuser.me/api/portraits/women/65.jpg",
		quote:
			"I'm satisfied with the service. Velorcrypt keeps me informed about updates and provides daily account summaries. The support team is very responsive and always ready to help.",
	},
	{
		name: "Emily Parker",
		title: "Graphic Designer, Creative Minds",
		image: "https://randomuser.me/api/portraits/women/65.jpg",
		quote:
			"Velorcrypt is the best binary options broker I've come across. It offers more than five types of binary options, unlike other brokers. Payments are quick, and the overall experience is fantastic. Thanks to Velorcrypt!",
	},
	{
		name: "David Lee",
		title: "Financial Analyst, Market Insights",
		image: "https://randomuser.me/api/portraits/women/65.jpg",
		quote:
			"Exceptional support team. No issues with withdrawals. Excellent trading conditions — everything a trader could ask for!",
	},
];
// Carousel settings
const settings = {
	dots: true,
	infinite: true,
	speed: 600,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 3000,
	pauseOnHover: true,
	arrows: false,
};

const TestimonialCarousel = () => {
	return (
		<Box
			sx={{
				maxWidth: {
					xs: 340, // small screens
					sm: 600, // small to medium screens
					md: 800, // medium screens
					lg: 1000, // large screens
				},
				mx: "auto",
				p: 4,
				bgcolor: "black",
				color: "white",
				borderRadius: 2,
			}}>
			<Typography variant="h5" align="center" gutterBottom sx={{ mb: 3 }}>
				What Our Users Say
			</Typography>

			<div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
				<img src={clientcomment} alt="client-comment" />

				<Slider {...settings}>
					{testimonials.map((testimonial, index) => (
						<Box
							key={index}
							sx={{ px: 2, display: "flex", justifyContent: "center" }}>
							<Paper
								elevation={3}
								sx={{
									p: 3,
									maxWidth: 600,
									mx: "auto",
									textAlign: "center",
									bgcolor: "black",
									color: "white",
									borderRadius: 2,
								}}>
								{/* <Avatar
								src={testimonial.image}
								alt={testimonial.name}
								sx={{ width: 80, height: 80, mx: "auto", mb: 2 }}
							/> */}
								<Typography variant="h6" gutterBottom>
									{testimonial.name}
								</Typography>
								{/* <Typography
								variant="subtitle2"
								gutterBottom
								sx={{ textDecoration: "underline", fontStyle: "thin" }}>
								{testimonial.title}
							</Typography> */}
								<Typography variant="body1" sx={{ fontStyle: "italic", mt: 2 }}>
									"{testimonial.quote}"
								</Typography>
							</Paper>
						</Box>
					))}
				</Slider>
			</div>
		</Box>
	);
};

export default TestimonialCarousel;
